import { render } from "./DeskCalendarView.vue?vue&type=template&id=2604274a&scoped=true"
import script from "./DeskCalendarView.vue?vue&type=script&lang=js"
export * from "./DeskCalendarView.vue?vue&type=script&lang=js"

import "./DeskCalendarView.vue?vue&type=style&index=0&id=2604274a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2604274a"]])

export default __exports__